import React, { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Button from '@material-ui/core/Button';
import { instanceAxios } from '../InstanceAxios';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: 'gray',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

export default function StyledDropzone(props) {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
  } = useDropzone({ accept: 'image/*,.pdf,.pfx,.xlsx,.p12,.csv' });
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const classes = useStyles();

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragAccept, isDragActive, isDragReject]
  );

  const files = acceptedFiles.map((file, index) => (
    <p key={index}>{file.name}</p>
  ));

  const arrayFiles = acceptedFiles.map((file, index) => {
    return file;
  });

  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  return (
    <div className="container">
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <p>Arraste e solte anexos aqui, ou clique para selecionar os anexos</p>
        {files}
      </div>
      <div className={classes.wrapper}>
        <Button
          variant="contained"
          color="primary"
          className={buttonClassname}
          disabled={arrayFiles.length === 0}
          onClick={() => props.handleButtonClick(arrayFiles)}
          style={{ justifyContent: 'center', alignSelf: 'center' }}
        >
          Fazer upload
          {/* {loading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )} */}
        </Button>
      </div>
    </div>
  );
}
